module.exports = __webpack_public_path__ + "img/reveal-artwork.1c1aaec.jpg";